import axios from 'axios'
import { ElMessage, ElMessageBox, ElLoading } from 'element-plus'
import Config from './config.js'
import Auth from './auth.js'

const Util = {
  info(content, type = 'info', duration = 3000) {
    ElMessage({ message: content, type, duration, showClose: true, offset: 60 })
  },

  getApiUrl(path) {
    return Config.apiPre + path
  },

  getToken() {
    return localStorage.getItem(Config.tokenKey) || ''
  },

  getAccountInfo() {
    try {
      const raw = localStorage.getItem(Config.accountKey)
      return raw ? JSON.parse(raw) : null
    } catch (e) {
      return null
    }
  },

  formatParam(param, likeFields) {
    if (!likeFields) return param
    likeFields.forEach((field) => {
      if (param[field]) param[field] += ':'
    })
    return param
  },

  confirm(message, title = '提示', options = {}) {
    return ElMessageBox.confirm(message, title, { type: 'warning', ...options })
      .then(() => true)
      .catch(() => false)
  },

  ajax(options, callback, showLoading = false) {
    const url = options.url
    const method = (options.method || 'POST').toUpperCase()
    const isJson = options.isJson
    let param = options.data
    const token = this.getToken()
    let params

    if (param && !isJson && method === 'POST') {
      params = new URLSearchParams()
      Object.keys(param).forEach((key) => {
        if (param[key] !== undefined && param[key] !== null) {
          params.append(key, param[key])
        }
      })
    } else {
      params = param
    }

    const headers = {
      'Content-Type': isJson ? 'application/json' : 'application/x-www-form-urlencoded'
    }
    if (token) headers.token = token

    let loadingInstance
    if (showLoading) {
      loadingInstance = ElLoading.service({
        lock: true,
        text: '加载中...',
        background: 'rgba(0,0,0,0)',
        customClass: 'my-loading'
      })
    }

    const req = method === 'GET'
      ? axios.get(url, { params, headers })
      : axios.post(url, params, { headers })

    return req.then((response) => {
      if (showLoading && loadingInstance) loadingInstance.close()
      const body = response.data
      if (body.resultCode === 2005 || body.resultCode === 2008) {
        Auth.exit()
        return Promise.reject(new Error('token expired'))
      }
      if (body.resultCode !== 1) {
        this.info(body.resultMsg || '请求失败', 'error')
        return Promise.reject(new Error(body.resultMsg || 'request failed'))
      }
      if (callback) callback(body.data)
      return body.data
    }).catch((e) => {
      if (showLoading && loadingInstance) loadingInstance.close()
      throw e
    })
  },

  ajaxGet(path, callback, showLoading = false) {
    return this.ajax({ method: 'GET', url: this.getApiUrl(path) }, callback, showLoading)
  },

  getUrl(url, defaultUrl = '') {
    if (!url) return defaultUrl
    if (url.indexOf('http') === 0) return url
    if (url.charAt(0) !== '/') url = '/' + url
    return Config.resPre + url
  },

  formatTime(timestamp, format = 'yyyy-MM-dd HH:mm') {
    if (!timestamp) return ''
    const date = new Date(timestamp)
    if (isNaN(date.getTime())) return ''
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    const hours = String(date.getHours()).padStart(2, '0')
    const minutes = String(date.getMinutes()).padStart(2, '0')
    return format
      .replace('yyyy', year)
      .replace('MM', month)
      .replace('dd', day)
      .replace('HH', hours)
      .replace('mm', minutes)
  },

  splitSecond(seconds) {
    if (!seconds) return '0分钟'
    const m = Math.floor(seconds / 60)
    const s = seconds % 60
    if (m > 0 && s > 0) return `${m}分${s}秒`
    if (m > 0) return `${m}分钟`
    return `${s}秒`
  },

  getTimeStatus(beginDate, endDate) {
    const now = Date.now()
    if (beginDate && now < new Date(beginDate).getTime()) return '未开始'
    if (endDate && now > new Date(endDate).getTime()) return '已结束'
    return '进行中'
  },

  parseDate(val) {
    if (!val) return null
    return new Date(typeof val === 'number' ? val : String(val).replace(/-/g, '/'))
  },

  setRouter(router) {
    window.$memberRouter = router
  },

  getRouter() {
    return window.$memberRouter
  }
}

export default Util
